var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-cell',{attrs:{"center":"","value":_vm.value,"required":_vm.formCreateInject.rule.validate[0].required,"input-align":"right","title":_vm.formCreateInject.prop.title.title},scopedSlots:_vm._u([{key:"right-icon",fn:function(){return [_c('div',{staticClass:"mounte_container",attrs:{"id":_vm.containerid}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }